<template>
  <user-login-wrapper>
    <el-card class="full-card" shadow="always">
      <template #header>
        <div>
          <span class="applicant_title">新規登録</span>
        </div>
      </template>
      <template #default>
        <double-scroll :leftSpan="24">
          <template #left>
            <proximity-info
              :isEdit="true"
              :isShow="false"
              :isShowConfirmDialog="false"
              :requestHeaderId="0"
              :returnToList="true"
              :isActionBtnVisible="false"
              :isEditBtnVisible="true"
              :isHistoryTableVisible="false"
            />
          </template>
        </double-scroll>
      </template>
    </el-card>
  </user-login-wrapper>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import UserLoginWrapper from '@/components/auth-wrappers/UserLoginWrapper.vue'
import ProximityInfo from '@/components/layout/ProximityInfo.vue'
import DoubleScroll from '@/components/layout/DoubleScroll.vue'
import { RequestHeaderProximityForm } from '@/types/forms'

/**
 * 近接工事申請件名新規登録
 */
export default defineComponent({
  name: 'ProximityAdd',
  components: {
    UserLoginWrapper,
    ProximityInfo,
    DoubleScroll,
  },
  setup() {
    const detail = ref<RequestHeaderProximityForm | null>(null)
    return {
      detail,
    }
  },
})
</script>

<style lang="scss" scoped>
.el-collapse {
  border-top: none;
  border-bottom: none;
}
.el-collapse-item {
  ::v-deep(.el-collapse-item__content) {
    padding-bottom: 0px !important;
  }
  ::v-deep(.el-collapse-item__wrap) {
    border-top: none !important;
    border-bottom: none !important;
  }
  ::v-deep(.el-collapse-item__header) {
    border-top: none !important;
    border-bottom: none !important;
  }
}
.action-buttons {
  flex-wrap: wrap;
  margin-left: -5px;
  margin-right: -5px;
  margin-top: -5px;
  padding-bottom: 10px;
  .el-button {
    margin-left: 5px;
    margin-right: 5px;
    margin-top: 5px;
  }
}
.input-group-dark {
  margin-top: 8px;
  margin-bottom: 8px;
}
.right-panels {
  margin-top: -8px;
  margin-bottom: -8px;
}

.el-descriptions {
  ::v-deep(.el-descriptions__label) {
    width: 90px;
  }
}
</style>
